import { createVanIconComponent } from "./van"

const BirthdayCakeOutlined = createVanIconComponent("birthday-cake-o")
export default BirthdayCakeOutlined
